<template>
  <van-overlay :show="show" >
    <div class="tips">
      <div class="item">
        <img
          src="https://static.xchengtech.cn/359faecfb7f54b5db54443123b0d24e7.png"
          alt=""
        />
      </div>
      <div class="item">
        <span>1. 点击右上角按钮 “ ... ”</span>
        <span>2. 点击 “ <van-icon name="share" size="5vw" /> ” 转发给朋友</span>
        <div>
          <van-button
            round
            type="info"
            color="#1b6bfe"
            @click.stop="show = false"
            >知道了</van-button
          >
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import Vue from "vue";
import { Overlay } from "vant";
import { Icon } from "vant";
import { Button } from "vant";

Vue.use(Button);
Vue.use(Icon);

Vue.use(Overlay);
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style scoped>
.tips {
  padding: 4vw;
  align-items: center;
}
.tips .item:nth-of-type(1) {
  display: flex;
  justify-content: right;
}
.tips .item:nth-of-type(1) img {
  display: block;
  width: 20vw;
}
.tips .item:nth-of-type(2) {
  padding-top: 2vw;
  display: grid;
  justify-content: center;
  color: white;
  font-size: 5vw;
  gap: 2vw;
}.tips .item:nth-of-type(2) span:nth-of-type(2){
    padding-bottom: 2vw;
}
.tips .item:nth-of-type(2) div {
  display: flex;
  justify-content: right;
}
.tips .item:nth-of-type(2) div .van-button {
  height: 0;
  font-size: 4vw;
  padding: 4vw 6vw;
}
</style>


// WEBPACK FOOTER //
// src/view/productDetail/modoule/shareTips.vue